import { Autocomplete, styled, TextField } from "@mui/material";

export const CustomAutocomplete = styled(Autocomplete)`
  & .MuiOutlinedInput-root {
    border-radius: 7px;
  }
`;
